import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { TranslationProvider } from "./utils/LangContext";

import PublicGames from "./pages/PublicGames";
import PublicGameChoice from "./pages/public-game/PublicGameChoice";
import PublicCreateTeam from "./pages/public-game/PublicCreateTeam";
import PublicJoinTeam from "./pages/public-game/PublicJoinTeam";

import Contact from "./pages/Contact";
import Game from "./pages/Game";
import Leaderboard from "./pages/Leaderboard";

import PrivateGameChoice from "./pages/private-game/PrivateGameChoice";
import PrivateCreateTeam from "./pages/private-game/PrivateCreateTeam";
import PrivateJoinTeam from "./pages/private-game/PrivateJoinTeam";
import MobileRequirements from "./pages/MobileRequirements";

//Fontawesome
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";


library.add(fas);
library.add(far);

function App() {
  return (
    <TranslationProvider>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          <Route path="/" element={<PublicGames />} />
          <Route path="/public-games" element={<PublicGames />} />

          {/* Public Game Routes */}
          <Route path="/public-game/:hash" element={<PublicGameChoice />} />
          <Route path="/public/create-team" element={<PublicCreateTeam />} />
          <Route path="/public/join-team" element={<PublicJoinTeam />} />

          {/* Private Game Routes */}
          <Route path="/private-game" element={<PrivateGameChoice />} />
          <Route path="/private/create-team" element={<PrivateCreateTeam />} />
          <Route path="/private/join-team" element={<PrivateJoinTeam />} />

          {/* Shared Routes */}
          <Route path="/game" element={<Game />} />
          <Route path="/leaderboard/:hash" element={<Leaderboard />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/mobile-requirements" element={<MobileRequirements />} />
        </Routes>
      </Router>
    </TranslationProvider>
  );
}

export default App;
